import React from 'react';
import { Else, If, Then } from 'react-if';

import { CarouselItem } from '@/components/@base/carousel';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import ProductsCarousel from '@/components/app/home/components/@shared/carousel';
import SuggestedAlternativeProductCard from '@/components/app/product/components/suggested-alternative-products/suggested-alternative-product-card';
import Props from '@/components/app/product/components/suggested-alternative-products/type';

import { pageLevelLocalization } from '@/constant/localization';
const { product: productLocalization } = pageLevelLocalization;

export default function SuggestedAlternativeProducts({ data }: Props) {
  return (
    <Container className='mb-5 pl-5  pr-3.5 md:mb-0 md:px-0 '>
      <Container className='mb-4 mt-2 h-[1px] bg-[#F5F6F9] md:hidden'></Container>
      <Text className='mb-[9px] whitespace-nowrap text-lg font-extraBold leading-7 text-[#5B5C60] md:text-sm lg:text-lg'>
        <If condition={data.length === 1}>
          <Then>{productLocalization.suggestedAlternativeProduct}</Then>
          <Else>{productLocalization.suggestedAlternativeProducts}</Else>
        </If>
      </Text>
      <ProductsCarousel
        arrowClassName='block w-[42px] h-[42px] md:h-[53px] md:w-[53px]'
        className='rounded-lg border border-[#F4F4F4] bg-white py-0! md:mr-0 md:max-h-[208px] md:max-w-[195px] md:flex-col md:text-center  md:shadow-[0px_10px_35px_0px_#7E899B1F] lg:ml-2.5! lg:mr-3! lg:pt-5!'
      >
        {data.map((item) => (
          <CarouselItem key={item.id}>
            <SuggestedAlternativeProductCard data={item} />
          </CarouselItem>
        ))}
      </ProductsCarousel>
    </Container>
  );
}
